import Toast from "@moltech/molui/toast";
import { getSystemHealthSettings } from "../../utils/dev/devApiErrorStore";

/**
 * Fire SystemHealth purge for a target; returns true on success.
 * @param {Function} postData - RTK usePostDataMutation trigger
 * @param {"errors"|"execution"|"agents"|"activity"} target
 * @param {number} [days]
 */
export async function runSystemHealthPurge(postData, target, days) {
  const retention =
    days ?? getSystemHealthSettings().purgeRetentionDays ?? 15;
  const res = await postData({
    url: "/SystemHealth/PurgeLogs",
    data: { target, days: retention },
  });
  if (res?.error || res?.data?.success === false) {
    Toast.error(res?.data?.message || "Purge failed.");
    return false;
  }
  Toast.success(res?.data?.message || "Purge complete.");
  return true;
}

export const getHealthRetentionDays = () =>
  getSystemHealthSettings().purgeRetentionDays ?? 15;
